// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogRouteRouteImport } from './routes/_blog/route'
import { Route as BlogArchiveRouteRouteImport } from './routes/_blog/_archive.route'
import { Route as AboutIndexRouteImport } from './routes/about.index'
import { Route as AboutLangRouteImport } from './routes/about.$lang'
import { Route as BlogArchivePostsIndexRouteImport } from './routes/_blog/_archive.posts.index'
import { Route as BlogPostsLangSlugRouteImport } from './routes/_blog/posts.$lang.$slug'
import { Route as BlogArchivePostsLangIndexRouteImport } from './routes/_blog/_archive.posts.$lang.index'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogRouteRoute = BlogRouteRouteImport.update({
            id: '/_blog',getParentRoute: () => rootRouteImport
          })
const BlogArchiveRouteRoute = BlogArchiveRouteRouteImport.update({
            id: '/_archive',getParentRoute: () => BlogRouteRoute
          })
const AboutIndexRoute = AboutIndexRouteImport.update({
            id: '/about/',path: '/about/',getParentRoute: () => rootRouteImport
          })
const AboutLangRoute = AboutLangRouteImport.update({
            id: '/about/$lang',path: '/about/$lang',getParentRoute: () => rootRouteImport
          })
const BlogArchivePostsIndexRoute = BlogArchivePostsIndexRouteImport.update({
            id: '/posts/',path: '/posts/',getParentRoute: () => BlogArchiveRouteRoute
          })
const BlogPostsLangSlugRoute = BlogPostsLangSlugRouteImport.update({
            id: '/posts/$lang/$slug',path: '/posts/$lang/$slug',getParentRoute: () => BlogRouteRoute
          })
const BlogArchivePostsLangIndexRoute = BlogArchivePostsLangIndexRouteImport.update({
            id: '/posts/$lang/',path: '/posts/$lang/',getParentRoute: () => BlogArchiveRouteRoute
          })





const BlogArchiveRouteRouteChildren = {
  BlogArchivePostsIndexRoute: BlogArchivePostsIndexRoute,BlogArchivePostsLangIndexRoute: BlogArchivePostsLangIndexRoute
}

const BlogArchiveRouteRouteWithChildren = BlogArchiveRouteRoute._addFileChildren(BlogArchiveRouteRouteChildren)



const BlogRouteRouteChildren = {
  BlogArchiveRouteRoute: BlogArchiveRouteRouteWithChildren,BlogPostsLangSlugRoute: BlogPostsLangSlugRoute
}

const BlogRouteRouteWithChildren = BlogRouteRoute._addFileChildren(BlogRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,BlogRouteRoute: BlogRouteRouteWithChildren,AboutLangRoute: AboutLangRoute,AboutIndexRoute: AboutIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)